module.exports = __webpack_public_path__ + "static/media/tree.630a7935.svg";